var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3516_48734)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 2.08008H3C2.60218 2.08008 2.22064 2.23811 1.93934 2.51942C1.65804 2.80072 1.5 3.18225 1.5 3.58008V21.5801C1.5 21.9779 1.65804 22.3594 1.93934 22.6407C2.22064 22.922 2.60218 23.0801 3 23.0801H21C21.3978 23.0801 21.7794 22.922 22.0607 22.6407C22.342 22.3594 22.5 21.9779 22.5 21.5801V3.58008C22.5 3.18225 22.342 2.80072 22.0607 2.51942C21.7794 2.23811 21.3978 2.08008 21 2.08008ZM3 0.580078C2.20435 0.580078 1.44129 0.896149 0.87868 1.45876C0.316071 2.02137 0 2.78443 0 3.58008L0 21.5801C0 22.3757 0.316071 23.1388 0.87868 23.7014C1.44129 24.264 2.20435 24.5801 3 24.5801H21C21.7956 24.5801 22.5587 24.264 23.1213 23.7014C23.6839 23.1388 24 22.3757 24 21.5801V3.58008C24 2.78443 23.6839 2.02137 23.1213 1.45876C22.5587 0.896149 21.7956 0.580078 21 0.580078L3 0.580078Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12.5801C6 12.3812 6.07902 12.1904 6.21967 12.0497C6.36032 11.9091 6.55109 11.8301 6.75 11.8301H17.25C17.4489 11.8301 17.6397 11.9091 17.7803 12.0497C17.921 12.1904 18 12.3812 18 12.5801C18 12.779 17.921 12.9698 17.7803 13.1104C17.6397 13.2511 17.4489 13.3301 17.25 13.3301H6.75C6.55109 13.3301 6.36032 13.2511 6.21967 13.1104C6.07902 12.9698 6 12.779 6 12.5801Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3516_48734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.580078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.9680e0dada5c7119e0046797bd02f888.svg";
export { ForwardRef as ReactComponent };